import React from "react";
import { array, bool, string, func, object } from "prop-types";
import { MemberDirectory } from "../../../molecules/member-directory";

export const MemberDirectoryTab = ({
  filteredMembers,
  membersLoading,
  membersError,
  selectedCities,
  availableCities,
  primaryRole,
  onSearchChange,
  onCityFilterChange,
  onRetry,
  onRemoveCityFilter,
  onClearAllFilters
}) => {
  return (
    <MemberDirectory
      members={filteredMembers}
      primaryRole={primaryRole}
      onSearch={onSearchChange}
      isLoading={membersLoading}
      error={membersError}
      onRetry={onRetry}
      availableCities={availableCities}
      selectedCities={selectedCities}
      onCityFilter={onCityFilterChange}
      onRemoveCityFilter={onRemoveCityFilter}
      onClearAllFilters={onClearAllFilters}
    />
  );
};

MemberDirectoryTab.propTypes = {
  filteredMembers: array.isRequired,
  membersLoading: bool.isRequired,
  membersError: string,
  selectedCities: array.isRequired,
  availableCities: array.isRequired,
  onSearchChange: func.isRequired,
  onCityFilterChange: func.isRequired,
  onRetry: func.isRequired,
  onRemoveCityFilter: func.isRequired,
  onClearAllFilters: func.isRequired
};